import * as React from "react";
import { Mutation, MutationResult } from "react-apollo";
import {
  UpsertRoleMutation,
  UpsertRoleMutationVariables,
  RoleCreateInput
} from "../../__generated__/types";
import { UPSERT_ROLE_MUTATION } from "./queries";
import { ROLE_BY_NAME_QUERY } from "src/queries/RoleQuery/queries";
import { ROLES_QUERY } from "src/queries/RolesQuery/queries";
import { message } from "antd";

interface Role {
  ldapDN?: string | null;
  ldapUUID?: string | null;
  name: string;
  scopes?: string[];
  default?: boolean | null;
}

class UpsertMutation extends Mutation<
  UpsertRoleMutation,
  UpsertRoleMutationVariables
> {}

export interface Props {
  name: string | null;
  add?: boolean;
  children(
    upsert: (data: Role) => void,
    result: MutationResult<UpsertRoleMutation>
  ): JSX.Element | null;
}

export interface State {}

export default class UpsertRole extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <UpsertMutation
        mutation={UPSERT_ROLE_MUTATION}
        refetchQueries={
          this.props.name
            ? [
                {
                  query: ROLE_BY_NAME_QUERY,
                  variables: { name: this.props.name }
                },
                { query: ROLES_QUERY }
              ]
            : [{ query: ROLES_QUERY }]
        }
        awaitRefetchQueries={true}
      >
        {(update, result) => {
          const updateFn = (data: Role) => {
            const name = this.props.name || data.name;
            const input: RoleCreateInput = {
              name: data.name,
              default: data.default,
              scopes: data.scopes && { set: data.scopes }
            };
            update({
              variables: {
                create: this.props.add ? input : { name: name! },
                name: name,
                update: this.props.add ? {} : input
              }
            }).then(() => {
              message.success(
                name + " " + this.props.add ? "created" : "updated"
              );
            });
          };
          return this.props.children(updateFn, result);
        }}
      </UpsertMutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mutations/UpsertRole/UpsertRole.tsx